module.exports = new __parcel__URL__("Mkt Plan Hover.8897bfdd.svg").toString();